module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/create-partner/create-partner.component.css
// module id = ./src/app/create-partner/create-partner.component.css
// module chunks = main